import {DataContext} from "../../../helper/HelperOne";
import {useState} from "react";
import NavBar from "../../nav_bar/Navbar";
import TaskPriorityList from "./TaskPriorityList";


function TaskPriority() {
    const [searchUi, setSearchUi] = useState(true)
    const [searchData, setSearchData] = useState(null)

    return (

        <DataContext.Provider value={{searchUi, setSearchUi, searchData, setSearchData}}>
            <NavBar
                childrenPage={<TaskPriorityList/>}
                menuId={6}
            />
        </DataContext.Provider>
    )
}

export default TaskPriority